import { TagDTO } from '../dtos/Tag.dto';
import { TagModel } from '../models/Tag.model';

export class TagUtil {
  public static mapToViewModel(dto: TagDTO): TagModel {
    return {
      id: dto.id && dto.id,
      tag: dto.tag,
    };
  }
}
